import { useConnectivity } from "@/app-bridge/hooks/useConnectivity";

/**
 * Sant när vi verkligen når servern. Bygger på den gemensamma
 * uppkopplingsvakten, inte bara webbläsarens flagga (som ljuger i appen).
 * Alltid true vid SSR/första render.
 */
export function useOnline(): boolean {
  return useConnectivity().state === "online";
}
